// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import DealerHierarchy from '../../../../shared/components/facets/dealer-hierarchy';
import DealerHierarchyFacet from '../../../shared/state/dealer-hierarchy-facet';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import {FormattedMessage} from 'react-intl';
import TranslatedInput from '../../../../shared/components/translated-input';

function handleFilterInputChange(event) {

    this.updateFacetFilterText(event.target.value);

}

function handleDealerHierarchyChange(facets) {

    this.updateWipFacets(facets);

}

const DealerHierarchyFacetsAccordion = props => {

    const title = (
        <div className='dealer-hierarchy-facet-title'>
            <FormattedMessage id='DEALER_LOCATIONS'/>
        </div>
    );

    const body = (
        <div>
            <div className='rounded-bar'>
                <span className='icon-search'/>
                <TranslatedInput
                    className='rounded-input'
                    onChange={props::handleFilterInputChange}
                    placeholder='FILTER_PLACEHOLDER'
                    type='text'
                    value={props.facetFilterText}
                />
            </div>
            <DealerHierarchy
                filterPlaceholder='FILTER_PLACEHOLDER'
                onDealerHierarchyChange={props::handleDealerHierarchyChange}
                selectedAccounts={props.facets.selectedAccounts}
                selectedCities={props.facets.selectedCities}
                selectedLeadAccounts={props.facets.selectedLeadAccounts}
                selectedTerritories={props.facets.selectedTerritories}
                territories={props.filteredTerritories}
                useInBuiltFilter={false}
            />
        </div>
    );

    return (
        <section className='dealer-hierarchy-facet-accordion'>
            <Accordion
                accordionId='dealer-hierarchy-facet-accordion'
                body={body}
                isExpanded={props.isExpanded}
                onClick={props.onClick}
                title={title}
            />
        </section>
    );

};

DealerHierarchyFacetsAccordion.displayName = 'DealerHierarchyFacetsAccordion';
DealerHierarchyFacetsAccordion.propTypes = {
    facetFilterText: PropTypes.string.isRequired,
    facets: PropTypes.instanceOf(DealerHierarchyFacet).isRequired,
    filteredTerritories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    updateFacetFilterText: PropTypes.func.isRequired,
    updateWipFacets: PropTypes.func.isRequired
};

export default DealerHierarchyFacetsAccordion;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/facets/dealer-hierarchy-facet-accordion.js